import React from "react";
import PropTypes from "prop-types";

import styles from "./CustomProductOptionBrandRefresh.module.css";

const BrandRefreshTooltip = ({ description }) => {
  return (
    <div className={styles.tooltip} data-part="product-description-tooltip">
      <p className={styles.tooltipText}>{description}</p>
    </div>
  );
};

BrandRefreshTooltip.propTypes = {
  description: PropTypes.string,
};

BrandRefreshTooltip.defaultProps = {
  description: "",
};

export default BrandRefreshTooltip;
